import React from "react";

import ErrorAlert from "../ErrorAlert";
import { WideCell } from "./Empty";

export interface ErrorProps {
  size: number;
}

const Error: React.FC<ErrorProps> = ({ size }) => {
  return (
    <WideCell colSpan={size}>
      <ErrorAlert />
    </WideCell>
  );
};

export default Error;
